import React from "react";
import { MessageCircle } from "lucide-react";
import { steps, company } from "../mock";

const HowToBuy = () => {
  return (
    <section id="come-acquistare" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-[#0f2846] text-3xl md:text-4xl font-bold">Come acquistare in 4 semplici passi</h2>
          <div className="w-24 h-1 bg-[#e8464a] mx-auto mt-4 rounded-full" />
          <p className="text-slate-500 mt-5">Dal preventivo alla consegna del motore: il processo è chiaro, veloce e senza sorprese.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {steps.map((s, i) => (
            <div key={i} className="relative bg-[#f4f6f9] rounded-2xl p-6 pt-9 border border-slate-100 hover:shadow-lg transition-all">
              <div className="absolute -top-5 left-6 w-11 h-11 rounded-full bg-[#e8464a] text-white font-display font-bold text-lg flex items-center justify-center shadow-md shadow-[#e8464a]/30">{s.n}</div>
              <h3 className="font-display font-bold text-[#0f2846] text-lg">{s.title}</h3>
              <p className="text-slate-500 text-sm mt-3 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <a href={company.whatsappLink} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-[#22c35e] hover:bg-[#1da851] text-white font-semibold px-8 py-3.5 rounded-lg transition-all hover:-translate-y-0.5 shadow-lg shadow-[#22c35e]/30">
            <MessageCircle size={18} /> Inizia ora con WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowToBuy;
